// Force refresh v3 - CACHE BUST
import MapContainer from './map/MapContainer';
import LiveMapContainer from './map/LiveMapContainer';

interface MapProps {
  sourceMode?: string;
  mapFilterScope?: 'full' | 'raceLegOnly';
  liveMode?: boolean;
  exploreUserEventsUi?: boolean;
  [key: string]: any;
}

export default function Map(props: MapProps) {
  if (props?.liveMode) {
    return <LiveMapContainer {...props} />;
  }
  const sourceMode = props?.sourceMode || 'single';
  return <MapContainer {...props} sourceMode={sourceMode} enableTimeWindow={true} />;
}
